export default "__VITE_ASSET__167ef310__"